import React, { useState, useEffect } from 'react';
import { connect, useDispatch } from "react-redux";
import { authActions, fazendaAction } from '../_actions';
import { withRouter } from '../_helpers/withRouter';
import { history } from '../_helpers';
import DataTable from 'react-data-table-component';
import { Button, Container, Row, Col, Card, CardBody, CardHeader, UncontrolledTooltip, Input } from 'reactstrap';
import NavBar from '../_components/navbar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle, faPen, faTrash } from '@fortawesome/free-solid-svg-icons'

const Fazenda = (props) => {

    const [id, setId] = useState(-1);
    const [edit, setEdit] = useState("");
    const [term, setTerm] = useState('');

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fazendaAction.getFazenda(true));
    }, []);

    const { fazenda } = props.fazenda;

    const columns = [
        {
            name: 'Nome da Fazenda',
            selector: row => `${row.nome}`,
            sortable: true
        },
        {
            name: 'Empresa',
            selector: row => `${row.Empresa ? row.Empresa.nome : ''}`,
            sortable: true
        },
        {
            name: 'Ações',
            sortable: false,
            right: true,
            cell: row => <>
                <Button
                    color="primary" size="sm"
                    className={id == row.id ? edit : ''}
                    component='a' href={`/fazenda/${row.id}`}>
                    {id == row.id ? '' : <FontAwesomeIcon icon={faPen} />}
                </Button>
                <span>{'\u00A0'}</span>
                <Button color="danger" size="sm"
                    className="ml-1"
                    onClick={(event) => handleClick(event, row.id)}>
                    <FontAwesomeIcon icon={faTrash} />
                </Button>
            </>,
        },
    ];

    const handleChange = prop => event => {
        setTerm(event.target.value);
    };

    const handleClick = (event, id) => {
        dispatch(fazendaAction.deleteFazendaById(id));
    };


    return (
        <div>
            <NavBar {...props} />
            <Container>
                <Card>
                    <CardHeader>
                        <Row>
                            <Col md={8}>
                                <h5 className="left">Lista de Fazendas</h5>
                            </Col>
                            {authActions.isGestor() ? (
                                <Col md={4} className="d-flex flex-row-reverse">
                                    <Button id="btnNovo" color="primary" className="btn-sm" component='a' onClick={() => history.push("/fazenda")} href="">Novo <FontAwesomeIcon icon={faPlusCircle} /></Button>
                                    <UncontrolledTooltip placement="bottom" target="btnNovo">
                                        Adiciona uma nova Fazenda
                                    </UncontrolledTooltip>
                                </Col>
                            ) : (<span></span>)}
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <Row>
                            <Col md={4} >
                                <Input
                                    id="term"
                                    label="term"
                                    placeholder="Filtro"
                                    value={term}
                                    onChange={handleChange('term')}
                                />
                            </Col>
                        </Row>
                        <br />
                        <DataTable
                            title=""
                            columns={columns}
                            pagination={true}
                            striped={true}
                            noDataComponent="Sem registros para mostrar"
                            paginationComponentOptions={{ rowsPerPageText: 'Registros por página:', rangeSeparatorText: 'de', noRowsPerPage: false, selectAllRowsItem: false, selectAllRowsItemText: 'Tudo' }}
                            data={fazenda.filter((item) => {
                                if (term === "") {
                                    return item;
                                } else if (item.nome.toLowerCase().includes(term.toLowerCase())) {
                                    return item;
                                }
                            })}
                        />
                    </CardBody>
                </Card>
            </Container>
            
        </div>
    );
}


const mapStateToProps = (state) => {
    return {
        fazenda: state.fazenda
    };
};

const connectedFazendaPage = withRouter(connect(mapStateToProps, null, null, {
    pure: false
})(Fazenda));
export { connectedFazendaPage as Fazenda };